export const EXTERNAL_LINKS = {
  CAREERS_ADMIN: "https://careers.sisu.mx/admin",
}
